import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { useContext } from 'react';
import { useCommands } from 'utils/commands';
import { KeyboardKeybindingsTableRowContext } from '../../../../../utils/keyboardKeybindingsTableRowContext';
export const UnassignKeybindingsItem = () => {
    const { unassignKeybindings } = useCommands();
    const { closeDropdown } = useContext(DropdownButtonContext);
    const { enrichedCommand } = useContext(KeyboardKeybindingsTableRowContext);
    const { command: { name }, canUnassignKeybindings, } = enrichedCommand;
    const handleClick = () => {
        unassignKeybindings(name);
        closeDropdown();
    };
    return (_jsx(ButtonList.Item, Object.assign({ isDisabled: !canUnassignKeybindings, onClick: handleClick }, { children: "Unassign" })));
};
